import React from "react";

export default function StatusDot({ on, label }) {
  return (
    <div className="flex items-center gap-1 text-[10px]">
      <span className={`w-2 h-2 rounded-full ${on ? "bg-sage" : "bg-border"}`} />
      <span className={on ? "text-sage font-medium" : "text-muted-foreground"}>{label}</span>
    </div>
  );
}
